import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { startEditAdmin } from '../../store/actions/admin';

const styles = theme => ({
  root: {
    display: 'flex',
    height: '100px',
  },
  paper: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrow: {
    cursor:'pointer'
  },
  arrowIcon: {
    color: '#424242'
  },
  icon: {
    margin: theme.spacing.unit * 2,
  },
  nav: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }
});

class ClientPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
        key: 0
    };

    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
  }

  handlePreviousClick() {
    const { clients, startEditAdmin } = this.props;
    const { key } = this.state;
    let client;

    if(clients.length === 0) return;

    if(key <= 0) {
      this.setState({key: clients.length - 1});
      client = clients[clients.length - 1];
    } else {
      this.setState({key: key - 1})
      client = clients[key - 1];
    }

    startEditAdmin({client: client});
  }

  handleNextClick() {
    const { clients, startEditAdmin } = this.props;
    const { key } = this.state;
    let client;

    if(clients.length === 0) return;

    if(key >= (clients.length - 1)) {
      this.setState({key: 0});
      client = clients[0];
    } else {
      this.setState({key: key + 1})
      client = clients[key + 1];
    }

    startEditAdmin({client: client});
  }

  render() {
    const { classes, clients, startEditAdmin } = this.props;
    const { key } = this.state;

    let name = '';
    if (clients[key] !== undefined) {
      name = `${clients[key].firstName} ${clients[key].lastName}`;
      //TODO: this causes state to change in render, refactor out so that
      //this is a controlled component where next and previous update redux client
      startEditAdmin({client: clients[key]});
    }

    return(
      <div className={classes.root}>
        <Paper className={classes.paper} elevation={4}>
          <div className={classes.nav}>

            <div className={classes.arrow} onClick={this.handlePreviousClick}>
              <Icon className={classes.icon} style={{fontSize: '48px'}} color="action">arrow_back</Icon>
            </div>
            <Typography variant="display1" style={{textAlign: 'center', minWidth: '300px'}}>
              {name}
            </Typography>
            <div className={classes.arrow} onClick={this.handleNextClick}>
              <Icon className={classes.icon} style={{fontSize: '48px'}} color="action">arrow_forward</Icon>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

ClientPicker.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  clients: state.clientsState,
});

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (admin) => dispatch(startEditAdmin(admin))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(ClientPicker);
//export default withStyles(styles)(ClientPicker);



// WEBPACK FOOTER //
// ./src/components/clients/ClientPicker.jsx